<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter101embarrassment">CHAPTER 101 - EMBARRASSMENT</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter102upthemountainanddownthemountain">CHAPTER 102 - UP THE MOUNTAIN AND DOWN THE MOUNTAIN</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter103arrivingatlast">CHAPTER 103 - ARRIVING AT LAST</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter104inlet">CHAPTER 104 - INLET</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter105thereisakarstcave">CHAPTER 105 - THERE IS A KARST CAVE</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter106sleepingtogether">CHAPTER 106 - SLEEPING TOGETHER</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter107ashriek">CHAPTER 107 - A SHRIEK</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter108sleepingtogetheragain">CHAPTER 108 - SLEEPING TOGETHER AGAIN</a>
</li>
<li class="table-of-content">
<a href="#/8_chapter109harvestingrice">CHAPTER 109 - HARVESTING RICE</a>
</li>
<li class="table-of-content">
<span href="#/9_chapter110drinkalotofwine" title="Link target outside of Sample">CHAPTER 110 - DRINK A LOT OF WINE</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter111onthevillagebookelectionplan" title="Link target outside of Sample">CHAPTER 111 - ON THE VILLAGE BOOK ELECTION PLAN</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter112karstcavedevelopmentplan" title="Link target outside of Sample">CHAPTER 112 - KARST CAVE DEVELOPMENT PLAN</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter113electionsupportingdocuments" title="Link target outside of Sample">CHAPTER 113 - ELECTION SUPPORTING DOCUMENTS</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter114spendingmoneytorepairtheroad" title="Link target outside of Sample">CHAPTER 114 - SPENDING MONEY TO REPAIR THE ROAD</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter115talktoyouracquaintances" title="Link target outside of Sample">CHAPTER 115 - TALK TO YOUR ACQUAINTANCES</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter116kongsensparalysisduetoimpact" title="Link target outside of Sample">CHAPTER 116 - KONG SEN'S PARALYSIS DUE TO IMPACT</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter117kongshenwokeup" title="Link target outside of Sample">CHAPTER 117 - KONG SHEN WOKE UP</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter118promulgatedmarriage" title="Link target outside of Sample">CHAPTER 118 - PROMULGATED MARRIAGE</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter119conventionalmethodoftastingwine" title="Link target outside of Sample">CHAPTER 119 - CONVENTIONAL METHOD OF TASTING WINE</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter120accompanyingkongmenghan" title="Link target outside of Sample">CHAPTER 120 - ACCOMPANYING KONG MENGHAN</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter121upperhook" title="Link target outside of Sample">CHAPTER 121 - UPPER HOOK</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter122contestmixing" title="Link target outside of Sample">CHAPTER 122 - CONTEST MIXING</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter123aglassofbluechampagneforeachperson" title="Link target outside of Sample">CHAPTER 123 - A GLASS OF BLUE CHAMPAGNE FOR EACH PERSON</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter124gohomeafterthevictory" title="Link target outside of Sample">CHAPTER 124 - GO HOME AFTER THE VICTORY</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter125theunreasonablerequestofkongmenghan" title="Link target outside of Sample">CHAPTER 125 - THE UNREASONABLE REQUEST OF KONG MENGHAN</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter126repeatedapologiesfailed" title="Link target outside of Sample">CHAPTER 126 - REPEATED APOLOGIES FAILED</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter127appreciation" title="Link target outside of Sample">CHAPTER 127 - APPRECIATION</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter128fake" title="Link target outside of Sample">CHAPTER 128 - FAKE</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter129personallyapologize" title="Link target outside of Sample">CHAPTER 129 - PERSONALLY APOLOGIZE</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter130hemeetoldpeopleinhisvillage" title="Link target outside of Sample">CHAPTER 130 - HE MEET OLD PEOPLE IN HIS VILLAGE</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter131takeoutevidence" title="Link target outside of Sample">CHAPTER 131 - TAKE OUT EVIDENCE</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter132boating" title="Link target outside of Sample">CHAPTER 132 - BOATING</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter133emergencysituation" title="Link target outside of Sample">CHAPTER 133 - EMERGENCY SITUATION</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter134swimbacktoshore" title="Link target outside of Sample">CHAPTER 134 - SWIM BACK TO SHORE</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter135safearrival" title="Link target outside of Sample">CHAPTER 135 - SAFE ARRIVAL</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter136imonmywayback" title="Link target outside of Sample">CHAPTER 136 - I'M ON MY WAY BACK</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter137analysisofthekillersorigin" title="Link target outside of Sample">CHAPTER 137 - ANALYSIS OF THE KILLER'S ORIGIN</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter138lettersofdismissal" title="Link target outside of Sample">CHAPTER 138 - LETTERS OF DISMISSAL</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter139encounteringbigbossontheway" title="Link target outside of Sample">CHAPTER 139 - ENCOUNTERING BIG BOSS ON THE WAY</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter140happytwopeople" title="Link target outside of Sample">CHAPTER 140 - HAPPY TWO PEOPLE</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter141beingfoundout" title="Link target outside of Sample">CHAPTER 141 - BEING FOUND OUT</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter142findtherightplace" title="Link target outside of Sample">CHAPTER 142 - FIND THE RIGHT PLACE</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter143getaknifescar" title="Link target outside of Sample">CHAPTER 143 - GET A KNIFE SCAR</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter144truedry" title="Link target outside of Sample">CHAPTER 144 - TRUE DRY</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter145longtimenosee" title="Link target outside of Sample">CHAPTER 145 - LONG TIME NO SEE</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter146scratchrice" title="Link target outside of Sample">CHAPTER 146 - SCRATCH RICE</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter147asmallcontest" title="Link target outside of Sample">CHAPTER 147 - A SMALL CONTEST</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter148perfectcompetition" title="Link target outside of Sample">CHAPTER 148 - PERFECT COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter149proposeafriendlyrelationshipwithyaoyao" title="Link target outside of Sample">CHAPTER 149 - PROPOSE A FRIENDLY RELATIONSHIP WITH YAO YAO</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter150cousinbrotherandsister" title="Link target outside of Sample">CHAPTER 150 - COUSIN BROTHER AND SISTER</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter151yaoyaosfather" title="Link target outside of Sample">CHAPTER 151 - YAO YAO'S FATHER</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter152lessonrascal" title="Link target outside of Sample">CHAPTER 152 - LESSON RASCAL</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter153wakingupfromanightmare" title="Link target outside of Sample">CHAPTER 153 - WAKING UP FROM A NIGHTMARE</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter154foodstrategy" title="Link target outside of Sample">CHAPTER 154 - FOOD STRATEGY</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter155explaintokongmenghan" title="Link target outside of Sample">CHAPTER 155 - EXPLAIN TO KONG MENGHAN</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter156imetaknifescaragain" title="Link target outside of Sample">CHAPTER 156 - I MET A KNIFE SCAR AGAIN</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter157resolveguchangfan" title="Link target outside of Sample">CHAPTER 157 - RESOLVE GU CHANGFAN</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter158beautypill" title="Link target outside of Sample">CHAPTER 158 - BEAUTY PILL</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter159aboutthepharmaceuticalfactory" title="Link target outside of Sample">CHAPTER 159 - ABOUT THE PHARMACEUTICAL FACTORY</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter160helpyourlittlesistergetbackonherfeet" title="Link target outside of Sample">CHAPTER 160 - HELP YOUR LITTLE SISTER GET BACK ON HER FEET</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter161bringbackaburdensome" title="Link target outside of Sample">CHAPTER 161 - BRING BACK A BURDENSOME</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter162hehadsuccessfullyrefinedthefirstbeautypellet" title="Link target outside of Sample">CHAPTER 162 - HE HAD SUCCESSFULLY REFINED THE FIRST BEAUTY PELLET.</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter163selfactingknife" title="Link target outside of Sample">CHAPTER 163 - SELF-ACTING KNIFE</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter164firstexperimenter" title="Link target outside of Sample">CHAPTER 164 - FIRST EXPERIMENTER</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter165hermotherinlawtriedbeautypill" title="Link target outside of Sample">CHAPTER 165 - HER MOTHER-IN-LAW TRIED BEAUTY PILL</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter166organizeanauction" title="Link target outside of Sample">CHAPTER 166 - ORGANIZE AN AUCTION</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter167perfecteffect" title="Link target outside of Sample">CHAPTER 167 - PERFECT EFFECT</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter168shewascalledtoschoolbyyaoyao" title="Link target outside of Sample">CHAPTER 168 - SHE WAS CALLED TO SCHOOL BY YAO YAO.</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter169watchrace" title="Link target outside of Sample">CHAPTER 169 - WATCH RACE</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter170stimulationpoint" title="Link target outside of Sample">CHAPTER 170 - STIMULATION POINT</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter171gamevictory" title="Link target outside of Sample">CHAPTER 171 - GAME VICTORY</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter172getridoftwopeopleandgoback" title="Link target outside of Sample">CHAPTER 172 - GET RID OF TWO PEOPLE AND GO BACK</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter173triad" title="Link target outside of Sample">CHAPTER 173 - TRIAD</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter174fourthstageoftheprofoundart" title="Link target outside of Sample">CHAPTER 174 - FOURTH STAGE OF THE PROFOUND ART</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter175resultofstimulatingthedoctor" title="Link target outside of Sample">CHAPTER 175 - RESULT OF STIMULATING THE DOCTOR</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter176darkwar" title="Link target outside of Sample">CHAPTER 176 - DARK WAR</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter177steppoint" title="Link target outside of Sample">CHAPTER 177 - STEP POINT</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter178operation007" title="Link target outside of Sample">CHAPTER 178 - OPERATION 007</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter179bounce" title="Link target outside of Sample">CHAPTER 179 - BOUNCE</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter180toothfortooth" title="Link target outside of Sample">CHAPTER 180 - TOOTH FOR TOOTH</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter181designcounterattack" title="Link target outside of Sample">CHAPTER 181 - DESIGN COUNTERATTACK</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter182establishmentoffirstgrouppharmaceuticalindustry" title="Link target outside of Sample">CHAPTER 182 - ESTABLISHMENT OF FIRST GROUP PHARMACEUTICAL INDUSTRY</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter183openingceremonyinvitation" title="Link target outside of Sample">CHAPTER 183 - OPENING CEREMONY INVITATION</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter184parturient" title="Link target outside of Sample">CHAPTER 184 - PARTURIENT</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter185onlythendidherememberyaoyao" title="Link target outside of Sample">CHAPTER 185 - ONLY THEN DID HE REMEMBER YAOYAO.</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter186ahoodlumonasnackstreet" title="Link target outside of Sample">CHAPTER 186 - A HOODLUM ON A SNACK STREET</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter187therearealsobarricades" title="Link target outside of Sample">CHAPTER 187 - THERE ARE ALSO BARRICADES</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter188welcomeceremony" title="Link target outside of Sample">CHAPTER 188 - WELCOME CEREMONY</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter189chasebyadog" title="Link target outside of Sample">CHAPTER 189 - CHASE BY A DOG</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter190humiliatemayor" title="Link target outside of Sample">CHAPTER 190 - HUMILIATE MAYOR</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter191talkthingsoverinbed" title="Link target outside of Sample">CHAPTER 191 - TALK THINGS OVER IN BED</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter192straighttothecountymagistrate" title="Link target outside of Sample">CHAPTER 192 - STRAIGHT TO THE COUNTY MAGISTRATE.</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter193protect" title="Link target outside of Sample">CHAPTER 193 - PROTECT</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter194planback" title="Link target outside of Sample">CHAPTER 194 - PLAN BACK</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter195artificialaccident" title="Link target outside of Sample">CHAPTER 195 - ARTIFICIAL ACCIDENT</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter196dirtychenligong" title="Link target outside of Sample">CHAPTER 196 - DIRTY CHEN LI GONG</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter197afterdanger" title="Link target outside of Sample">CHAPTER 197 - AFTER DANGER</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter198strangenews" title="Link target outside of Sample">CHAPTER 198 - STRANGE NEWS</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter199toseethecar" title="Link target outside of Sample">CHAPTER 199 - TO SEE THE CAR</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter200facesmackingsalesperson" title="Link target outside of Sample">CHAPTER 200 - FACE-SMACKING SALESPERSON</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?cce2b26e